// extracted by mini-css-extract-plugin
export default {"Select":"Settings_Select__k+Jf+","SettingsContent":"Settings_SettingsContent__0jMjk"};